
import Breadcrumb from '@/components/Breadcrumb'
import TitleBox from '@/components/CSS/TitleBox'
import GoodsListPage from '@/components/GoodsListPage'
// import { listNewsPage } from "@/api/common";

export default {
	components: {
		Breadcrumb,
		GoodsListPage,
		TitleBox
	},
	data() {
		return {
			loading: null,
			navIndex: 'null',
			pageInfo: {
				page: 1,
				pageSize: 10,
				total: 0
			},
			newList: [],
			navList: [
				{
					label: '全部',
					value: 'null'
				},
				{
					label: '普通公告',
					value: 'NORMAL'
				},
				{
					label: '找回案例',
					value: 'FIND_CASE'
				},
				{
					label: '诉讼文书',
					value: 'LITIGANT_DOCUMENTS'
				}
			]
		}
	},
	beforeRouteEnter(to, from, next) {
		// 如果不是从详情过来的就刷新缓存
		if (from.path !== '/article') {
			to.meta.reload = true
		}
		next()
	},
	// activated() {
	//   if (this.$route.meta.reload) {
	//     // 选中index
	//     this.navIndex = this.$route.query.type;
	//     // 清理已有列表的数据，重新请求数据，如果不清除的话就会有之前的商品缓存，延迟显示最新的商品
	//     this.newList = [];
	//     // 请求数据
	//     this.getListNewsPage();
	//   }
	//   //重新设置当前路由的reload
	//   this.$route.meta.reload = false;
	// },
	methods: {
		handleCurrentChange(page) {
			this.pageInfo.page = page
			this.getListNewsPage()
		},
		handleSizeChange(pageSize) {
			this.pageInfo.page = 1
			this.pageInfo.pageSize = pageSize
			this.getListNewsPage()
		},
		getListNewsPage() {
			this.loading = true
			let p = {
				action: {
					type: this.navIndex == 'null' ? null : this.navIndex
				},
				page: this.pageInfo.page,
				pageSize: this.pageInfo.pageSize
			}
			this.$api.listNewsPage(p).then(res => {
				this.loading = false
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				let data = res.data
				this.newList = data.records
				this.pageInfo.total = data.total
				this.pageInfo.page = data.page
			})
		},
		changeNav(item) {
			this.navIndex = item.value
			localStorage.setItem('articleType', item.value)
			this.getListNewsPage()
		},
		gotoArticle(item) {
			this.$router.push({
				name: 'article',
				params: { id: item.id }
			})
		}
	},
	mounted() {
		if (localStorage.getItem('articleType') == this.$route.params.type) {
			localStorage.setItem('articleType', this.$route.params.type)
		} else {
			this.navIndex = localStorage.getItem('articleType')
		}
		if (this.$route.meta.reload) {
			// 清理已有列表的数据，重新请求数据，如果不清除的话就会有之前的商品缓存，延迟显示最新的商品
			this.newList = []
			// 请求数据
			this.getListNewsPage()
		}
		//重新设置当前路由的reload
		this.$route.meta.reload = false
	}
}
